import { cx } from "shared/utils";
import { PreviewFrame } from "./PreviewFrame";

const CHECKS: {
  label: string;
  points: string;
  mark: "done" | "partly" | "missed";
}[] = [
  { label: "Greeting", points: "10 / 10", mark: "done" },
  { label: "Needs discovery", points: "10 / 20", mark: "partly" },
  { label: "Showing offered", points: "0 / 30", mark: "missed" },
  { label: "Contact info captured", points: "20 / 20", mark: "done" },
  { label: "Next step agreed", points: "0 / 20", mark: "missed" }
];

const MARK_SYMBOLS = { done: "✓", partly: "½", missed: "✕" };

const MARK_TONES = {
  done: "bg-success-50 text-success-700",
  partly: "bg-warning-50 text-warning-700",
  missed: "bg-danger-50 text-danger-500"
};

export const CallCoachPreview = () => (
  <PreviewFrame badge="pro" innerClassName="flex-col gap-3 px-6 py-5">
    <div className="flex w-full items-center gap-3">
      <span className="flex h-11 w-14 items-center justify-center rounded-lg bg-danger-50 text-xl font-bold text-danger-500">
        40
      </span>
      <div className="space-y-0.5">
        <p className="text-sm font-bold text-content-1000">Call Coach</p>
        <p className="flex items-center gap-2 text-[13px] font-bold text-content-1000">
          Missed opportunity
          <span className="rounded-full bg-danger-50 px-2 py-0.5 text-xs font-medium text-danger-500">
            Lead leak
          </span>
        </p>
      </div>
      <span className="ml-auto text-xs font-medium text-content-300">
        out of 100
      </span>
    </div>
    <ul className="w-full space-y-1.5">
      {CHECKS.map((check) => (
        <li
          key={check.label}
          className="flex items-center gap-3 text-[13px] font-medium text-content-1000"
        >
          <span
            aria-hidden="true"
            className={cx(
              "flex size-5 shrink-0 items-center justify-center rounded-full text-xs font-bold",
              MARK_TONES[check.mark]
            )}
          >
            {MARK_SYMBOLS[check.mark]}
          </span>
          <span className="flex-1">{check.label}</span>
          <span className="text-content-400">{check.points}</span>
        </li>
      ))}
    </ul>
  </PreviewFrame>
);
